import config from '@config';
import {
  initializeHttp,
  setupCookieUnauthorizedInterceptorFabric,
  setupCsrfInterceptor,
  setupRequestInterceptor,
} from '@gasbi/shared/common/utils/http';

// Cookie (BFF) session (GSB-7560): every request carries X-CSRF for the API's CSRF guard, and a
// 401 (no session) navigates to the cabinet API's login endpoint. Someone who signed in but has
// no representative in this cabinet gets a 403, which the session bootstrap shows as "not
// authorized".
const instance = initializeHttp(config.VITE_API_URL, [
  setupRequestInterceptor,
  setupCsrfInterceptor,
  setupCookieUnauthorizedInterceptorFabric('/api/login'),
]);

export default instance;
